<div class="landing">

  

  <app-home-header></app-home-header>

  <!--  <div class="features" id="booking-steps" >
          <div class="container">
            <div class="row"> 
                 <div class="col-md-6 col-sm-12" >
                  <img src="assets/images/about.png" class="doctor img-fluid">
                 </div>

                 <div class="col-md-6 col-sm-12" >
                   <div class="book">
                  <div class="row ">
                    <div class="col-6"> 
                    <i class="fas fa-sign-in-alt "></i>
                     <h3>تسجيل الدخول </h3>
                    <p> أولا قم بتسجيل دخولك</p>  
                    </div>
                    <div class="col-6"> 

                      <i class="fas fa-stethoscope "></i>
                      <h3>  عيادة </h3>
                      <p>  اختر العياده او التخصص   الذي تريده </p>  
                    </div>
                    <div class="col-6"> 
                      <i class="fas fa-user-md "></i>
                      <h3> دكتور</h3>
                      <p> اختر الدكتور الذي تريده</p>  
                    </div>
                    <div class="col-6">                        
                      <i class="far fa-calendar-check "></i>
                      <h3> اختيار موعد</h3>
                      <p> اختر الموعد المناسب وقم بتأكيد حجزك</p>       
                    </div>
                </div>  
                </div>   
                  </div>

        </div>
    </div>
</div>  -->

  <!--  <div class=" stat" id="statistics" >
    <div class="container">
      <div class="sec-header">
        <h2>إحصائيات المركز</h2>
        </div>
      <p>لوريم ايبسوم دولار سيت أميت ,كونسيكتيتور أدايبا يسكينج أليايت,سيت دو أيوسمود تيمبورنكايديديونتيوت لابوري ات دولار ماجنا أليكيوا . يوت انيم أد مينيم فينايم,كيواس نوستريدأكسير سيتاشن يللأمكو لابورأس نيسي يت أليكيوب أكس أيا كوممودو كونسيكيوات . ديواس
      </p>
        
        <div class="row">
        
         <div class="col-md-3 col-sm-6" >
             <div class="statis">
              <h3 style="color: lightskyblue;">+2000</h3>
                 <p>طبيب </p>
             </div>
        </div>
            
             <div class="col-md-3 col-sm-6">
             <div class="statis" style="text-align: center; ">
              <h3 style="color:blueviolet;">+9900</h3>
                 <p>مريض </p>
             
             </div>
            
        </div>
            
             <div class="col-md-3 col-sm-6">
             <div class="statis" style="text-align: center; ">
              <h3 style="color: sienna;">+100</h3>
                 <p>تخصص </p>
             
             </div>
            
        </div>
            
             <div class="col-md-3 col-sm-6">
             <div class="statis" style="text-align: center;">
              <h3 style="color:coral;">+4400</h3>
                 <p>حجز </p>
             
             </div>
            
        </div>
        </div>
    </div>
</div> 
 -->
 <div class="steps">
  <div class="container">

 <div class="sec-header">
  <h2 style="color:#120f4b;"> <span>{{'landing.booking' | translate}}  </span></h2>
  </div>
 <ul class="progress-indicator"> 
   <li class="completed"> 
     <span class="bubble"> 
      <img  src="assets/images/account.png"  alt="seu">     
    </span>{{'landing.login' | translate}}
     </li>

     <li class="active"> 
      <span class="bubble"> 
        <img  src="assets/images/major2.png"  alt="seu">     
      </span>{{'Booking.selectmajor' | translate}}
      </li> 

       <li class="completed"> 
      <span class="bubble"> 
        <img  src="assets/images/doctors.png"  alt="seu">     
      </span>{{'Booking.selectdoctor' | translate}}
      </li>

      <li class="active"> 
        <span class="bubble"> 
          <img  src="assets/images/hours2.png"  alt="seu">     
        </span> {{'landing.appi' | translate}}
        </li>
       </ul>

    </div>
  </div>
  <div class="news" id="news">
    <div class="container">
      <div class="sec-header2" style="text-align: center;">
        <h1> {{'menu.news' | translate}} </h1>
      </div>
      <div class="row">
      
        <div class="col-md-6">
          <img src="assets/images/about.png" class="dcnew img-fluid">
        </div>

        <div class="col-md-6">
        

          <div class=" top-news" >
            <div class="item" >
              <div class="list-n" *ngFor="let it of news" >
                <div class="widget-body" >
                  <div class="row  align-items-center" >
                    <div class="col-md-3 col-xs-3">
                      <div class="icon">
                        <img src="{{it.pictureUrl ||'assets/images/fLdfB6pQdb.png'}}" alt="SEU">
                      </div>
                    </div>
                    <div class="col-md-9 col-xs-9">
                      <div class="state">
                        <h2 class="success"> {{it.title}} </h2>
                        <h6 class="success">{{it.body}}</h6>
                      </div>
                    </div>

                  </div>
                </div>

              </div>
            </div>

            
          </div>
         
        </div>
       

      </div>
    </div>
  </div>


  <app-home-footer></app-home-footer>

</div>